const breakpoints = {
    xs: 375,
    sm: 544,
    md: 768,
    lg: 1024,
    xl: 1200,
    xxl: 1600,
};

export { breakpoints };
//# sourceMappingURL=breakpoints.js.map
